import { selectors } from 'modules/common';
import { domain } from 'modules/data';
import { useSelector } from 'modules/react-redux';
import { useParams } from 'react-router-dom';

import { useBillLinkedToAirwallexBatchPayment } from '../../hooks/useBillLinkedToAirwallexBatchPayment';
import { useBillLinkedToAmaxPayXeroBatchPayment } from '../../hooks/useBillLinkedToAmaxPayXeroBatchPayment';
import { useBillLinkedToXeroBatchPayment } from '../../hooks/useBillLinkedToXeroBatchPayment';
import { EditWatchersPopupData } from '../../reducers/page/activePopup/editWatchersPopupReducer';
import { getActivePopup, getActiveRequestSafe } from '../../selectors/pageSelectors';

export const useGetRequest = () => {
    const { requestId } = useSelector(getActivePopup<EditWatchersPopupData>);
    const requestFromRedux = useSelector((state) => selectors.request.findRequestById(state, requestId));

    const { companyId } = useParams<{ companyId: string }>();
    const activeRequest = useSelector(getActiveRequestSafe);
    const airwallexBatchPaymentRequestId =
        activeRequest?.integrationCode === domain.IntegrationCode.XeroAirwallexBatchPayment ? activeRequest.id : '';
    const xeroBatchPaymentRequestId =
        activeRequest?.integrationCode === domain.IntegrationCode.XeroBillBatchPayment ? activeRequest.id : '';
    const amaxPayBatchPaymentRequestId =
        activeRequest?.integrationCode === domain.IntegrationCode.XeroAmaxPayBatchPayment ? activeRequest.id : '';

    const { request: airwallexRequest } = useBillLinkedToAirwallexBatchPayment(
        {
            companyId,
            billId: requestId,
            batchPaymentRequestId: airwallexBatchPaymentRequestId,
        },
        {
            enabled: !requestFromRedux && !!airwallexBatchPaymentRequestId,
        }
    );

    const { request: xeroRequest } = useBillLinkedToXeroBatchPayment(
        {
            path: {
                companyId,
                billRequestId: requestId,
                batchPaymentRequestId: xeroBatchPaymentRequestId,
            },
        },
        { enabled: !requestFromRedux && !!xeroBatchPaymentRequestId }
    );

    const { request: amaxPayRequest } = useBillLinkedToAmaxPayXeroBatchPayment(
        {
            path: {
                companyId,
                billRequestId: requestId,
                batchPaymentRequestId: amaxPayBatchPaymentRequestId,
            },
        },
        {
            enabled: !requestFromRedux && !!amaxPayBatchPaymentRequestId,
        }
    );

    return requestFromRedux || airwallexRequest || xeroRequest || amaxPayRequest;
};
